import React from 'react';
import clsx from 'clsx';

import { createStyles } from "./styles";

var TableRow = function TableRow(props) {
  var classes = createStyles(props);
  var _onClick = props.onClick,className = props.className,children = props.children;
  return /*#__PURE__*/(
    React.createElement("tr", {
      id: props.id,
      className: clsx(classes.tableRow, className),
      onClick: function onClick(e) {return _onClick && _onClick(e);} },

    children));


};

export default TableRow;
//# sourceMappingURL=index.js.map